import { Phone, MessageCircle } from "lucide-react";
import { useConfig, whatsappHref, telHref } from "@/lib/config";

export default function StickyMobileCTA() {
  const cfg = useConfig();
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden grid grid-cols-2 border-t border-slate-200 shadow-2xl" data-testid="sticky-mobile-bar">
      <a
        href={whatsappHref(cfg.whatsapp_number, "Namaste! I need a shifting quote from Maa Vindhyavasini Packers Movers & Transport.")}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#22C55E] hover:bg-[#16A34A] text-white font-semibold py-4 grid place-items-center gap-1 text-sm"
        data-testid="sticky-whatsapp-mobile-button"
      >
        <MessageCircle className="w-5 h-5" /> WhatsApp
      </a>
      <a
        href={telHref(cfg.contact_phone)}
        className="bg-[#1E3A8A] hover:bg-[#0F172A] text-white font-semibold py-4 grid place-items-center gap-1 text-sm"
        data-testid="sticky-call-mobile-button"
      >
        <Phone className="w-5 h-5" /> Call Now
      </a>
    </div>
  );
}
